<template>
    <router-view />
</template>

<script>
    export default {
        name: 'StackScreen',
    }
</script>
